__turbopack_context__.v({
  "description": "input-wrapper-module__FcT5Dq__description",
  "label": "input-wrapper-module__FcT5Dq__label",
});
